import type * as React from 'react';
import { get } from '@Domain/Api';
import documentTypeSectionsFetched, {
	type DocumentTypeSectionsFetchedAction,
	type DocumentTypeSectionsPayload,
} from '@Application/Organizations/Workflows/Actions/documentTypeSectionsFetched';
import documentTypeSectionsFetchFailed, {
	type DocumentTypeSectionsFetchFailedAction,
} from '@Application/Organizations/Workflows/Actions/documentTypeSectionsFetchFailed';
import type FetchDocumentTypeSections from '@Application/Organizations/Workflows/Queries/FetchDocumentTypeSections';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = DocumentTypeSectionsFetchedAction | DocumentTypeSectionsFetchFailedAction;

export default (query: FetchDocumentTypeSections) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<DocumentTypeSectionsPayload>(
				`${parameters.api.host}/api/organizations/${query.organizationId}/document-types/${query.documentTypeId}/sections`,
			);

			const action = documentTypeSectionsFetched(payload, query.organizationId, query.documentTypeId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTypeSectionsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
